<ng-container *ngIf="this.isInitialized">
  <ng-container *ngIf="__ResultLiveData | async as __liveData">
    <div *ngIf="__liveData.length == 0" class="no-live-events">{{ 'no_live_events' | translate }}</div>
  </ng-container>

  <ng-container *ngFor="let dnm of __ResultLiveData | async | slice : 0 : sliceCount; index as i; last as lastItem; trackBy: pairWithMatchID">
    <ng-container *ngIf="this._DataHelper.liveFavoriteButtonStatus ? this._DataHelper.favList.includes(dnm.BetradarMatchId) : true">
      <!-- <div class="match-r-header" *ngIf="dnm.type === 'liveHeader'">
        <div class="match-r-header-left">
          <ng-container *ngIf="dnm.isAll || this._LiveStreamService.isOnTvButton || this._DataHelper.isMySlipButton; else sportText">
            <span class="match-text">{{ dnm.sportName }}-Live</span>
          </ng-container>
          <ng-template #sportText>
            <span class="match-text">Live</span>
          </ng-template>
          <span class="match-count">{{ dnm.liveCount }}</span>
        </div>
      </div> -->
      <div class="match-r-header" *ngIf="dnm.type === 'upComingHeader'">
        <div class="match-r-header-left">
          <ng-container *ngIf="dnm.isAll || this._LiveStreamService.isOnTvButton || this._DataHelper.isMySlipButton; else sportText">
            <span class="match-text">{{ dnm.sportName }}-{{ 'Upcoming' | translate }}</span>
          </ng-container>
          <ng-template #sportText>
            <span class="match-text">{{ 'Upcoming' | translate }}</span>
          </ng-template>
          <span class="match-count">{{ dnm.upComingCount }} </span>
        </div>
      </div>
      <div class="match-row-header" *ngIf="dnm.type === 'TournamentName'">
        <image-loader-flag-utils [url]="dnm.IsoName == null ? 'un' : dnm.IsoName" [isFlags]="true" extraClasses="flag-rounded"></image-loader-flag-utils>
        <div class="tournament-container">
          <span style="margin-right: 5px">
            {{ dnm.TournamentName.split('/')[1] }}
          </span>
          <span style="font-weight: 400">
            {{ dnm.TournamentName.split('/')[0] }}
          </span>
        </div>
      </div>
      <div *ngIf="dnm.type === 'liveNotFound'">
        <div class="no-live-events">{{ 'no_live_events' | translate }}</div>
      </div>
      <div class="match-row-header pre-line" *ngIf="dnm.type === 'typeOfMatch'">
        <div class="live-bar-container-mobile">
          <div class="live-bar-left">{{ this._DataHelper.liveHeaderTitle || this._DataHelper.selectedStoryItem?.sportName }} {{ 'Upcoming' | translate }}</div>
          <div class="live-bar-right">{{ this._DataHelper.comboSelectedOdd.OddNameLong | translate }}</div>
        </div>
        <div class="live-bar-container-desktop">
          <div class="live-bar-left">{{ this._DataHelper.selectedStoryItem?.sportName }} {{ 'Upcoming' | translate }}</div>
        </div>
      </div>
      <ng-container *ngIf="dnm.type !== 'Sport'">
        <match-r
          *ngIf="dnm.type === 'Match'"
          (addOdd)="addOddListener($event)"
          (eventDetailEventId)="eventDetailEventIdListener($event)"
          [_selectedOdds]="_selectedOdds"
          [_d]="dnm"
          [oddType]="oddLiveMarketingValue"
          [_sportName]="dnm.SportNameOriginal"
          [_isLive]="dnm.isLive"
          [_activeOddType]="oddLiveMarketingValue"></match-r>
        <ng-container *ngIf="eventDetailEventId != 0 && (dnm.MatchId == eventDetailEventId || dnm.EventId == eventDetailEventId) && dnm.isLive === true">
          <liveeventdetail-component [showLiveList]="false" [eventIdByInput]="eventDetailEventId"></liveeventdetail-component>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>
</ng-container>
<ng-container *ngIf="('livePageIsPagination' | getEnv) && this.isLoadMore">
  <div class="odd-box-row loadMore" *ngIf="isShowLoadMore">
    <div class="odd-box" (click)="handleNextData()">{{ 'Load_More' | translate }} ↓</div>
  </div>
</ng-container>
